/* src/components/ProviderReview/ProviderReview.svelte generated by Svelte v3.48.0 */
import {
	SvelteComponent,
	append_hydration,
	attr,
	children,
	claim_element,
	claim_space,
	claim_text,
	destroy_each,
	detach,
	element,
	init,
	insert_hydration,
	listen,
	noop,
	run_all,
	safe_not_equal,
	set_data,
	set_input_value,
	space,
	text
} from "svelte/internal";

import gql from 'nanographql';
import { onMount } from 'svelte';
import getGraphqlClient from '../../helpers/svelte/utils/getGraphqlClient';

function get_each_context(ctx, list, i) {
	const child_ctx = ctx.slice();
	child_ctx[25] = list[i];
	return child_ctx;
}

// (89:0) {#if success}
function create_if_block(ctx) {
	let div;
	let t;

	return {
		c() {
			div = element("div");
			t = text("Your message was successfully received.");
			this.h();
		},
		l(nodes) {
			div = claim_element(nodes, "DIV", { class: true, role: true });
			var div_nodes = children(div);
			t = claim_text(div_nodes, "Your message was successfully received.");
			div_nodes.forEach(detach);
			this.h();
		},
		h() {
			attr(div, "class", "alert alert-success");
			attr(div, "role", "alert");
		},
		m(target, anchor) {
			insert_hydration(target, div, anchor);
			append_hydration(div, t);
		},
		d(detaching) {
			if (detaching) detach(div);
		}
	};
}

// (93:0) {#each errors as error}
function create_each_block(ctx) {
	let div;
	let t_value = /*error*/ ctx[25].message + "";
	let t;

	return {
		c() {
			div = element("div");
			t = text(t_value);
			this.h();
		},
		l(nodes) {
			div = claim_element(nodes, "DIV", { class: true, role: true });
			var div_nodes = children(div);
			t = claim_text(div_nodes, t_value);
			div_nodes.forEach(detach);
			this.h();
		},
		h() {
			attr(div, "class", "alert alert-danger");
			attr(div, "role", "alert");
		},
		m(target, anchor) {
			insert_hydration(target, div, anchor);
			append_hydration(div, t);
		},
		p(ctx, dirty) {
			if (dirty & /*errors*/ 64 && t_value !== (t_value = /*error*/ ctx[25].message + "")) set_data(t, t_value);
		},
		d(detaching) {
			if (detaching) detach(div);
		}
	};
}

function create_fragment(ctx) {
	let t0;
	let t1;
	let div6;
	let h2;
	let t2;
	let t3;
	let t4;
	let form;
	let div0;
	let label0;
	let input0;
	let t5;
	let span0;
	let t6;
	let label1;
	let input1;
	let t7;
	let span1;
	let t8;
	let span2;
	let t9;
	let label2;
	let input2;
	let t10;
	let span3;
	let t11;
	let span4;
	let t12;
	let span5;
	let t13;
	let label3;
	let input3;
	let t14;
	let span6;
	let t15;
	let span7;
	let t16;
	let span8;
	let t17;
	let span9;
	let t18;
	let label4;
	let input4;
	let t19;
	let span10;
	let t20;
	let span11;
	let t21;
	let span12;
	let t22;
	let span13;
	let t23;
	let span14;
	let t24;
	let div1;
	let label5;
	let t25;
	let t26;
	let input5;
	let t27;
	let div2;
	let label6;
	let t28;
	let t29;
	let input6;
	let t30;
	let div3;
	let label7;
	let t31;
	let t32;
	let input7;
	let t33;
	let div4;
	let label8;
	let t34;
	let t35;
	let textarea;
	let t36;
	let div5;
	let button0;
	let t37;
	let t38;
	let button1;
	let t39;
	let mounted;
	let dispose;
	let if_block = /*success*/ ctx[7] && create_if_block(ctx);
	let each_value = /*errors*/ ctx[6];
	let each_blocks = [];

	for (let i = 0; i < each_value.length; i += 1) {
		each_blocks[i] = create_each_block(get_each_context(ctx, each_value, i));
	}

	return {
		c() {
			if (if_block) if_block.c();
			t0 = space();

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].c();
			}

			t1 = space();
			div6 = element("div");
			h2 = element("h2");
			t2 = text("Write a Review of ");
			t3 = text(/*name*/ ctx[0]);
			t4 = space();
			form = element("form");
			div0 = element("div");
			label0 = element("label");
			input0 = element("input");
			t5 = space();
			span0 = element("span");
			t6 = space();
			label1 = element("label");
			input1 = element("input");
			t7 = space();
			span1 = element("span");
			t8 = space();
			span2 = element("span");
			t9 = space();
			label2 = element("label");
			input2 = element("input");
			t10 = space();
			span3 = element("span");
			t11 = space();
			span4 = element("span");
			t12 = space();
			span5 = element("span");
			t13 = space();
			label3 = element("label");
			input3 = element("input");
			t14 = space();
			span6 = element("span");
			t15 = space();
			span7 = element("span");
			t16 = space();
			span8 = element("span");
			t17 = space();
			span9 = element("span");
			t18 = space();
			label4 = element("label");
			input4 = element("input");
			t19 = space();
			span10 = element("span");
			t20 = space();
			span11 = element("span");
			t21 = space();
			span12 = element("span");
			t22 = space();
			span13 = element("span");
			t23 = space();
			span14 = element("span");
			t24 = space();
			div1 = element("div");
			label5 = element("label");
			t25 = text("Name");
			t26 = space();
			input5 = element("input");
			t27 = space();
			div2 = element("div");
			label6 = element("label");
			t28 = text("Email");
			t29 = space();
			input6 = element("input");
			t30 = space();
			div3 = element("div");
			label7 = element("label");
			t31 = text("City, State");
			t32 = space();
			input7 = element("input");
			t33 = space();
			div4 = element("div");
			label8 = element("label");
			t34 = text("Review");
			t35 = space();
			textarea = element("textarea");
			t36 = space();
			div5 = element("div");
			button0 = element("button");
			t37 = text("Clear");
			t38 = space();
			button1 = element("button");
			t39 = text("Submit");
			this.h();
		},
		l(nodes) {
			if (if_block) if_block.l(nodes);
			t0 = claim_space(nodes);

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].l(nodes);
			}

			t1 = claim_space(nodes);
			div6 = claim_element(nodes, "DIV", { class: true });
			var div6_nodes = children(div6);
			h2 = claim_element(div6_nodes, "H2", { class: true });
			var h2_nodes = children(h2);
			t2 = claim_text(h2_nodes, "Write a Review of ");
			t3 = claim_text(h2_nodes, /*name*/ ctx[0]);
			h2_nodes.forEach(detach);
			t4 = claim_space(div6_nodes);
			form = claim_element(div6_nodes, "FORM", {});
			var form_nodes = children(form);
			div0 = claim_element(form_nodes, "DIV", { class: true });
			var div0_nodes = children(div0);
			label0 = claim_element(div0_nodes, "LABEL", { class: true });
			var label0_nodes = children(label0);
			input0 = claim_element(label0_nodes, "INPUT", { type: true, name: true, class: true });
			t5 = claim_space(label0_nodes);
			span0 = claim_element(label0_nodes, "SPAN", { class: true });
			children(span0).forEach(detach);
			label0_nodes.forEach(detach);
			t6 = claim_space(div0_nodes);
			label1 = claim_element(div0_nodes, "LABEL", { class: true });
			var label1_nodes = children(label1);
			input1 = claim_element(label1_nodes, "INPUT", { type: true, name: true, class: true });
			t7 = claim_space(label1_nodes);
			span1 = claim_element(label1_nodes, "SPAN", { class: true });
			children(span1).forEach(detach);
			t8 = claim_space(label1_nodes);
			span2 = claim_element(label1_nodes, "SPAN", { class: true });
			children(span2).forEach(detach);
			label1_nodes.forEach(detach);
			t9 = claim_space(div0_nodes);
			label2 = claim_element(div0_nodes, "LABEL", { class: true });
			var label2_nodes = children(label2);
			input2 = claim_element(label2_nodes, "INPUT", { type: true, name: true, class: true });
			t10 = claim_space(label2_nodes);
			span3 = claim_element(label2_nodes, "SPAN", { class: true });
			children(span3).forEach(detach);
			t11 = claim_space(label2_nodes);
			span4 = claim_element(label2_nodes, "SPAN", { class: true });
			children(span4).forEach(detach);
			t12 = claim_space(label2_nodes);
			span5 = claim_element(label2_nodes, "SPAN", { class: true });
			children(span5).forEach(detach);
			label2_nodes.forEach(detach);
			t13 = claim_space(div0_nodes);
			label3 = claim_element(div0_nodes, "LABEL", { class: true });
			var label3_nodes = children(label3);
			input3 = claim_element(label3_nodes, "INPUT", { type: true, name: true, class: true });
			t14 = claim_space(label3_nodes);
			span6 = claim_element(label3_nodes, "SPAN", { class: true });
			children(span6).forEach(detach);
			t15 = claim_space(label3_nodes);
			span7 = claim_element(label3_nodes, "SPAN", { class: true });
			children(span7).forEach(detach);
			t16 = claim_space(label3_nodes);
			span8 = claim_element(label3_nodes, "SPAN", { class: true });
			children(span8).forEach(detach);
			t17 = claim_space(label3_nodes);
			span9 = claim_element(label3_nodes, "SPAN", { class: true });
			children(span9).forEach(detach);
			label3_nodes.forEach(detach);
			t18 = claim_space(div0_nodes);
			label4 = claim_element(div0_nodes, "LABEL", { class: true });
			var label4_nodes = children(label4);
			input4 = claim_element(label4_nodes, "INPUT", { type: true, name: true, class: true });
			t19 = claim_space(label4_nodes);
			span10 = claim_element(label4_nodes, "SPAN", { class: true });
			children(span10).forEach(detach);
			t20 = claim_space(label4_nodes);
			span11 = claim_element(label4_nodes, "SPAN", { class: true });
			children(span11).forEach(detach);
			t21 = claim_space(label4_nodes);
			span12 = claim_element(label4_nodes, "SPAN", { class: true });
			children(span12).forEach(detach);
			t22 = claim_space(label4_nodes);
			span13 = claim_element(label4_nodes, "SPAN", { class: true });
			children(span13).forEach(detach);
			t23 = claim_space(label4_nodes);
			span14 = claim_element(label4_nodes, "SPAN", { class: true });
			children(span14).forEach(detach);
			label4_nodes.forEach(detach);
			div0_nodes.forEach(detach);
			t24 = claim_space(form_nodes);
			div1 = claim_element(form_nodes, "DIV", { class: true });
			var div1_nodes = children(div1);
			label5 = claim_element(div1_nodes, "LABEL", { class: true });
			var label5_nodes = children(label5);
			t25 = claim_text(label5_nodes, "Name");
			label5_nodes.forEach(detach);
			t26 = claim_space(div1_nodes);
			input5 = claim_element(div1_nodes, "INPUT", { type: true, class: true });
			div1_nodes.forEach(detach);
			t27 = claim_space(form_nodes);
			div2 = claim_element(form_nodes, "DIV", { class: true });
			var div2_nodes = children(div2);
			label6 = claim_element(div2_nodes, "LABEL", { class: true });
			var label6_nodes = children(label6);
			t28 = claim_text(label6_nodes, "Email");
			label6_nodes.forEach(detach);
			t29 = claim_space(div2_nodes);
			input6 = claim_element(div2_nodes, "INPUT", { type: true, class: true });
			div2_nodes.forEach(detach);
			t30 = claim_space(form_nodes);
			div3 = claim_element(form_nodes, "DIV", { class: true });
			var div3_nodes = children(div3);
			label7 = claim_element(div3_nodes, "LABEL", { class: true });
			var label7_nodes = children(label7);
			t31 = claim_text(label7_nodes, "City, State");
			label7_nodes.forEach(detach);
			t32 = claim_space(div3_nodes);
			input7 = claim_element(div3_nodes, "INPUT", { type: true, class: true });
			div3_nodes.forEach(detach);
			t33 = claim_space(form_nodes);
			div4 = claim_element(form_nodes, "DIV", { class: true });
			var div4_nodes = children(div4);
			label8 = claim_element(div4_nodes, "LABEL", { class: true });
			var label8_nodes = children(label8);
			t34 = claim_text(label8_nodes, "Review");
			label8_nodes.forEach(detach);
			t35 = claim_space(div4_nodes);
			textarea = claim_element(div4_nodes, "TEXTAREA", { class: true });
			children(textarea).forEach(detach);
			div4_nodes.forEach(detach);
			t36 = claim_space(form_nodes);
			div5 = claim_element(form_nodes, "DIV", { class: true });
			var div5_nodes = children(div5);
			button0 = claim_element(div5_nodes, "BUTTON", { type: true, class: true });
			var button0_nodes = children(button0);
			t37 = claim_text(button0_nodes, "Clear");
			button0_nodes.forEach(detach);
			t38 = claim_space(div5_nodes);

			button1 = claim_element(div5_nodes, "BUTTON", {
				type: true,
				class: true,
				"disabled:isprocessing": true
			});

			var button1_nodes = children(button1);
			t39 = claim_text(button1_nodes, "Submit");
			button1_nodes.forEach(detach);
			div5_nodes.forEach(detach);
			form_nodes.forEach(detach);
			div6_nodes.forEach(detach);
			this.h();
		},
		h() {
			attr(h2, "class", "heading-sm heading-sm--wide svelte-fkxqbi");
			attr(input0, "type", "radio");
			attr(input0, "name", "stars");
			input0.__value = "1";
			input0.value = input0.__value;
			attr(input0, "class", "svelte-fkxqbi");
			/*$$binding_groups*/ ctx[12][0].push(input0);
			attr(span0, "class", "review-form-stars__icon svelte-fkxqbi");
			attr(label0, "class", "review-form-stars__label svelte-fkxqbi");
			attr(input1, "type", "radio");
			attr(input1, "name", "stars");
			input1.__value = "2";
			input1.value = input1.__value;
			attr(input1, "class", "svelte-fkxqbi");
			/*$$binding_groups*/ ctx[12][0].push(input1);
			attr(span1, "class", "review-form-stars__icon svelte-fkxqbi");
			attr(span2, "class", "review-form-stars__icon svelte-fkxqbi");
			attr(label1, "class", "review-form-stars__label svelte-fkxqbi");
			attr(input2, "type", "radio");
			attr(input2, "name", "stars");
			input2.__value = "3";
			input2.value = input2.__value;
			attr(input2, "class", "svelte-fkxqbi");
			/*$$binding_groups*/ ctx[12][0].push(input2);
			attr(span3, "class", "review-form-stars__icon svelte-fkxqbi");
			attr(span4, "class", "review-form-stars__icon svelte-fkxqbi");
			attr(span5, "class", "review-form-stars__icon svelte-fkxqbi");
			attr(label2, "class", "review-form-stars__label svelte-fkxqbi");
			attr(input3, "type", "radio");
			attr(input3, "name", "stars");
			input3.__value = "4";
			input3.value = input3.__value;
			attr(input3, "class", "svelte-fkxqbi");
			/*$$binding_groups*/ ctx[12][0].push(input3);
			attr(span6, "class", "review-form-stars__icon svelte-fkxqbi");
			attr(span7, "class", "review-form-stars__icon svelte-fkxqbi");
			attr(span8, "class", "review-form-stars__icon svelte-fkxqbi");
			attr(span9, "class", "review-form-stars__icon svelte-fkxqbi");
			attr(label3, "class", "review-form-stars__label svelte-fkxqbi");
			attr(input4, "type", "radio");
			attr(input4, "name", "stars");
			input4.__value = "5";
			input4.value = input4.__value;
			attr(input4, "class", "svelte-fkxqbi");
			/*$$binding_groups*/ ctx[12][0].push(input4);
			attr(span10, "class", "review-form-stars__icon svelte-fkxqbi");
			attr(span11, "class", "review-form-stars__icon svelte-fkxqbi");
			attr(span12, "class", "review-form-stars__icon svelte-fkxqbi");
			attr(span13, "class", "review-form-stars__icon svelte-fkxqbi");
			attr(span14, "class", "review-form-stars__icon svelte-fkxqbi");
			attr(label4, "class", "review-form-stars__label svelte-fkxqbi");
			attr(div0, "class", "mb-3 review-form-stars svelte-fkxqbi");
			attr(label5, "class", "form-label svelte-fkxqbi");
			attr(input5, "type", "text");
			attr(input5, "class", "form-control svelte-fkxqbi");
			attr(div1, "class", "mb-3");
			attr(label6, "class", "form-label svelte-fkxqbi");
			attr(input6, "type", "email");
			attr(input6, "class", "form-control svelte-fkxqbi");
			attr(div2, "class", "mb-3");
			attr(label7, "class", "form-label svelte-fkxqbi");
			attr(input7, "type", "text");
			attr(input7, "class", "form-control svelte-fkxqbi");
			attr(div3, "class", "mb-3");
			attr(label8, "class", "form-label svelte-fkxqbi");
			attr(textarea, "class", "form-control svelte-fkxqbi");
			attr(div4, "class", "mb-3");
			attr(button0, "type", "button");
			attr(button0, "class", "btn btn-link svelte-fkxqbi");
			attr(button1, "type", "button");
			attr(button1, "class", "btn btn-primary");
			attr(button1, "disabled:isprocessing", "");
			attr(div5, "class", "d-flex justify-content-between btn-wrapper svelte-fkxqbi");
			attr(div6, "class", "review-form card card-body mt-5 svelte-fkxqbi");
		},
		m(target, anchor) {
			if (if_block) if_block.m(target, anchor);
			insert_hydration(target, t0, anchor);

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].m(target, anchor);
			}

			insert_hydration(target, t1, anchor);
			insert_hydration(target, div6, anchor);
			append_hydration(div6, h2);
			append_hydration(h2, t2);
			append_hydration(h2, t3);
			append_hydration(div6, t4);
			append_hydration(div6, form);
			append_hydration(form, div0);
			append_hydration(div0, label0);
			append_hydration(label0, input0);
			input0.checked = input0.__value === /*rating*/ ctx[2];
			append_hydration(label0, t5);
			append_hydration(label0, span0);
			append_hydration(div0, t6);
			append_hydration(div0, label1);
			append_hydration(label1, input1);
			input1.checked = input1.__value === /*rating*/ ctx[2];
			append_hydration(label1, t7);
			append_hydration(label1, span1);
			append_hydration(label1, t8);
			append_hydration(label1, span2);
			append_hydration(div0, t9);
			append_hydration(div0, label2);
			append_hydration(label2, input2);
			input2.checked = input2.__value === /*rating*/ ctx[2];
			append_hydration(label2, t10);
			append_hydration(label2, span3);
			append_hydration(label2, t11);
			append_hydration(label2, span4);
			append_hydration(label2, t12);
			append_hydration(label2, span5);
			append_hydration(div0, t13);
			append_hydration(div0, label3);
			append_hydration(label3, input3);
			input3.checked = input3.__value === /*rating*/ ctx[2];
			append_hydration(label3, t14);
			append_hydration(label3, span6);
			append_hydration(label3, t15);
			append_hydration(label3, span7);
			append_hydration(label3, t16);
			append_hydration(label3, span8);
			append_hydration(label3, t17);
			append_hydration(label3, span9);
			append_hydration(div0, t18);
			append_hydration(div0, label4);
			append_hydration(label4, input4);
			input4.checked = input4.__value === /*rating*/ ctx[2];
			append_hydration(label4, t19);
			append_hydration(label4, span10);
			append_hydration(label4, t20);
			append_hydration(label4, span11);
			append_hydration(label4, t21);
			append_hydration(label4, span12);
			append_hydration(label4, t22);
			append_hydration(label4, span13);
			append_hydration(label4, t23);
			append_hydration(label4, span14);
			append_hydration(form, t24);
			append_hydration(form, div1);
			append_hydration(div1, label5);
			append_hydration(label5, t25);
			append_hydration(div1, t26);
			append_hydration(div1, input5);
			set_input_value(input5, /*reviewerName*/ ctx[1]);
			append_hydration(form, t27);
			append_hydration(form, div2);
			append_hydration(div2, label6);
			append_hydration(label6, t28);
			append_hydration(div2, t29);
			append_hydration(div2, input6);
			set_input_value(input6, /*email*/ ctx[3]);
			append_hydration(form, t30);
			append_hydration(form, div3);
			append_hydration(div3, label7);
			append_hydration(label7, t31);
			append_hydration(div3, t32);
			append_hydration(div3, input7);
			set_input_value(input7, /*cityState*/ ctx[5]);
			append_hydration(form, t33);
			append_hydration(form, div4);
			append_hydration(div4, label8);
			append_hydration(label8, t34);
			append_hydration(div4, t35);
			append_hydration(div4, textarea);
			set_input_value(textarea, /*message*/ ctx[4]);
			append_hydration(form, t36);
			append_hydration(form, div5);
			append_hydration(div5, button0);
			append_hydration(button0, t37);
			append_hydration(div5, t38);
			append_hydration(div5, button1);
			append_hydration(button1, t39);

			if (!mounted) {
				dispose = [
					listen(input0, "change", /*input0_change_handler*/ ctx[11]),
					listen(input1, "change", /*input1_change_handler*/ ctx[13]),
					listen(input2, "change", /*input2_change_handler*/ ctx[14]),
					listen(input3, "change", /*input3_change_handler*/ ctx[15]),
					listen(input4, "change", /*input4_change_handler*/ ctx[16]),
					listen(input5, "input", /*input5_input_handler*/ ctx[17]),
					listen(input6, "input", /*input6_input_handler*/ ctx[18]),
					listen(input7, "input", /*input7_input_handler*/ ctx[19]),
					listen(textarea, "input", /*textarea_input_handler*/ ctx[20]),
					listen(button0, "click", /*reset*/ ctx[8]),
					listen(button1, "click", /*sendMessage*/ ctx[9]),
					listen(form, "submit", /*sendMessage*/ ctx[9])
				];

				mounted = true;
			}
		},
		p(ctx, [dirty]) {
			if (/*success*/ ctx[7]) {
				if (if_block) {
					
				} else {
					if_block = create_if_block(ctx);
					if_block.c();
					if_block.m(t0.parentNode, t0);
				}
			} else if (if_block) {
				if_block.d(1);
				if_block = null;
			}

			if (dirty & /*errors*/ 64) {
				each_value = /*errors*/ ctx[6];
				let i;

				for (i = 0; i < each_value.length; i += 1) {
					const child_ctx = get_each_context(ctx, each_value, i);

					if (each_blocks[i]) {
						each_blocks[i].p(child_ctx, dirty);
					} else {
						each_blocks[i] = create_each_block(child_ctx);
						each_blocks[i].c();
						each_blocks[i].m(t1.parentNode, t1);
					}
				}

				for (; i < each_blocks.length; i += 1) {
					each_blocks[i].d(1);
				}

				each_blocks.length = each_value.length;
			}

			if (dirty & /*name*/ 1) set_data(t3, /*name*/ ctx[0]);

			if (dirty & /*rating*/ 4) {
				input0.checked = input0.__value === /*rating*/ ctx[2];
			}

			if (dirty & /*rating*/ 4) {
				input1.checked = input1.__value === /*rating*/ ctx[2];
			}

			if (dirty & /*rating*/ 4) {
				input2.checked = input2.__value === /*rating*/ ctx[2];
			}

			if (dirty & /*rating*/ 4) {
				input3.checked = input3.__value === /*rating*/ ctx[2];
			}

			if (dirty & /*rating*/ 4) {
				input4.checked = input4.__value === /*rating*/ ctx[2];
			}

			if (dirty & /*reviewerName*/ 2 && input5.value !== /*reviewerName*/ ctx[1]) {
				set_input_value(input5, /*reviewerName*/ ctx[1]);
			}

			if (dirty & /*email*/ 8 && input6.value !== /*email*/ ctx[3]) {
				set_input_value(input6, /*email*/ ctx[3]);
			}

			if (dirty & /*cityState*/ 32 && input7.value !== /*cityState*/ ctx[5]) {
				set_input_value(input7, /*cityState*/ ctx[5]);
			}

			if (dirty & /*message*/ 16) {
				set_input_value(textarea, /*message*/ ctx[4]);
			}
		},
		i: noop,
		o: noop,
		d(detaching) {
			if (if_block) if_block.d(detaching);
			if (detaching) detach(t0);
			destroy_each(each_blocks, detaching);
			if (detaching) detach(t1);
			if (detaching) detach(div6);
			/*$$binding_groups*/ ctx[12][0].splice(/*$$binding_groups*/ ctx[12][0].indexOf(input0), 1);
			/*$$binding_groups*/ ctx[12][0].splice(/*$$binding_groups*/ ctx[12][0].indexOf(input1), 1);
			/*$$binding_groups*/ ctx[12][0].splice(/*$$binding_groups*/ ctx[12][0].indexOf(input2), 1);
			/*$$binding_groups*/ ctx[12][0].splice(/*$$binding_groups*/ ctx[12][0].indexOf(input3), 1);
			/*$$binding_groups*/ ctx[12][0].splice(/*$$binding_groups*/ ctx[12][0].indexOf(input4), 1);
			mounted = false;
			run_all(dispose);
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let { eiaid } = $$props;
	let { name } = $$props;

	const providerReview = gql`
    mutation providerReview(
      $email: String!
      $name: String!
      $message: String!
      $cityState: String!
      $rating: Int!
      $eiaid: String!
    ) {
      providerReview(
        input: { email: $email, name: $name, message: $message, cityState: $cityState, rating: $rating, eiaid: $eiaid }
      ) {
        response: string
      }
    }
  `;

	let reviewerName = '',
		rating = '',
		email = '',
		message = '',
		cityState = '',
		errors = [],
		success = false,
		isProcessing = false;

	let egKey = '';

	onMount(async () => {
		let egKeyDiv = document.getElementById('eg-key');
		if (egKeyDiv) egKey = egKeyDiv.dataset.egKey;
	});

	const graphql = getGraphqlClient();

	const reset = () => {
		$$invalidate(1, reviewerName = '');
		$$invalidate(2, rating = '');
		$$invalidate(3, email = '');
		$$invalidate(4, message = '');
		$$invalidate(5, cityState = '');
	};

	async function sendMessage() {
		isProcessing = true;

		let r = await graphql(
			providerReview({
				name: reviewerName,
				email,
				message,
				cityState,
				rating: Number(rating),
				eiaid
			}),
			{ 'eg-key': egKey }
		);

		console.log(r);

		if (r.errors) {
			$$invalidate(6, errors = r.errors);
			isProcessing = false;
		}

		if (r.data && r.data.providerReview && r.data.providerReview.response && r.data.providerReview.response === 'SUCCESS') {
			$$invalidate(6, errors = []);
			$$invalidate(7, success = true);
			isProcessing = false;

			setTimeout(
				() => {
					$$invalidate(7, success = false);
				},
				5000
			);

			reset();
		}
	} // console.log(r);

	const $$binding_groups = [[]];

	function input0_change_handler() {
		rating = this.__value;
		$$invalidate(2, rating);
	}

	function input1_change_handler() {
		rating = this.__value;
		$$invalidate(2, rating);
	}

	function input2_change_handler() {
		rating = this.__value;
		$$invalidate(2, rating);
	}

	function input3_change_handler() {
		rating = this.__value;
		$$invalidate(2, rating);
	}

	function input4_change_handler() {
		rating = this.__value;
		$$invalidate(2, rating);
	}

	function input5_input_handler() {
		reviewerName = this.value;
		$$invalidate(1, reviewerName);
	}

	function input6_input_handler() {
		email = this.value;
		$$invalidate(3, email);
	}

	function input7_input_handler() {
		cityState = this.value;
		$$invalidate(5, cityState);
	}

	function textarea_input_handler() {
		message = this.value;
		$$invalidate(4, message);
	}

	$$self.$$set = $$props => {
		if ('eiaid' in $$props) $$invalidate(10, eiaid = $$props.eiaid);
		if ('name' in $$props) $$invalidate(0, name = $$props.name);
	};

	return [
		name,
		reviewerName,
		rating,
		email,
		message,
		cityState,
		errors,
		success,
		reset,
		sendMessage,
		eiaid,
		input0_change_handler,
		$$binding_groups,
		input1_change_handler,
		input2_change_handler,
		input3_change_handler,
		input4_change_handler,
		input5_input_handler,
		input6_input_handler,
		input7_input_handler,
		textarea_input_handler
	];
}

class ProviderReview extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, { eiaid: 10, name: 0 });
	}
}

export default ProviderReview;